import {Pipe, PipeTransform} from '@angular/core';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';

/**
 * Casts an `AbstractControl` to `UntypedFormGroup` inside templates.
 *
 * Reactive forms in this app are 100% untyped, so `form.get('x')`, `form.controls.x`, and
 * `formArray.controls[i]` are all statically typed `AbstractControl`. Under AOT `strictTemplates`,
 * binding those to `[formGroup]` or reading `.controls` on them fails type-checking even though the
 * value IS a FormGroup at runtime. This pipe is a compile-time-only cast — it changes no runtime
 * behaviour. Being `pure`, Angular memoises it on the control reference, so it does not re-run every
 * change-detection cycle (unlike a method/getter call in the template).
 *
 * Usage:
 *   [formGroup]="entityForm.controls.x | asFormGroup"
 *   {{ (item | asFormGroup).controls.field.value }}
 */
@Pipe({
    name: 'asFormGroup',
    pure: true,
    standalone: true
})
export class AsFormGroupPipe implements PipeTransform {
    transform(control: AbstractControl | null | undefined): UntypedFormGroup {
        return control as UntypedFormGroup;
    }
}
